import React from 'react';

const SpeechBubblePlusCircle: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <circle cx="64" cy="64" r="57" stroke="#fff" strokeWidth="4"></circle>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M71.33 76.734c-11.471 0-20.767-9.296-20.767-20.766 0-11.47 9.296-20.766 20.766-20.766 11.47 0 20.766 9.296 20.766 20.766 0 5.73-2.32 10.92-6.083 14.683l6.083 6.083H71.33z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M46.776 48.553c-6.523 4.105-10.871 11.348-10.871 19.63a23.135 23.135 0 006.791 16.405l-6.791 6.804h23.209c7.806 0 14.695-3.86 18.897-9.772m.647-28.095h-4.886V48.64h-4.886v4.886H64v4.886h4.886v4.887h4.886V58.41h4.886v-4.886z"
    ></path>
  </svg>
);

export default SpeechBubblePlusCircle;
